export default __webpack_public_path__ + "static/media/timeframe_background.81ac3b1a.svg";